<template>
  <v-dialog
    v-model="dialog"
  >
    <v-card>
      <v-card-text v-if="loading" class="text-center">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        />
      </v-card-text>
      <v-card-text v-else>
        <apexchart type="bar" :height="height" :options="chartOptions" :series="series" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialog: true,
      loading: true,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          height: 350,
        },
        title: {
          text: this.title
        },
        xaxis: {
          categories: [],
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: '13px',
                  fontWeight: 900,
                },
              },
            },
          },
        },
        legend: {
          show: false
        }
      }
    }
  },
  watch: {
    dialog (val) {
      if (!val) {
        setTimeout(() => {
          this.$emit('close')
        }, 500)
      }
    },
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  computed: {
    height () {
      return Math.max(150 + this.chartOptions.xaxis.categories.length * 20, 350)
    }
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/${this.link}`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.series = data.series
        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            categories: data.tensionBeats
          }
        }
      }
      this.loading = false
    }
  }
}
</script>